export default "__VITE_ASSET__D2Hna3Q6__"